import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 开课码（查询列表）
 * @param {*} query
 */
export const  startProductCodelist = (query) => {
  return request({
      url: `${prefix}/product/startProductCode/list`,
      method: 'get',
      params: query
  })
}
/**
 * 开课码（批量删除）
 * @param {*} query
 */
export const  startProductCodeDelete = (query) => {
  return request({
      url: `${prefix}/product/startProductCode/list`,
      method: 'delete',
      data: query
  })
}
/**
 * 开课码（创建）
 * @param {*} query
 */
export const  startProductCodeCreate = (params) => {
  return request({
      url: `${prefix}/product/startProductCode/generateStartProductCode`,
      method: 'post',
      data: params,
  })
}
/**
 * 开课码（详情）
 * @param {*} query
 */
export const  startProductCodeDetail= (query) => {
  return request({
      url: `${prefix}/product/startProductCode`,
      method: 'get',
      params: query
  })
}
/**
 * 开课码（查询兑换记录）
 * @param {*} query
 */
export const  exchangeLogList= (query) => {
  return request({
      url: `${prefix}/product/startProductCode/exchangeLog/list`,
      method: 'get',
      params: query
  })
}
/**
 * 开课码（任务列表）
 * @param {*} query
 */
export const  taskList= (query) => {
  return request({
      url: `${prefix}/product/startProductCode/task/list`,
      method: 'get',
      params: query
  })
}
/**
 * 开课码（导出）
 * @param {*} query
 */

export const  taskExport= (query) => {
  return request({
      url: `${prefix}/product/startProductCode/task/export`,
      method: 'get',
      params: query
  })
}

/**
 * 批量作废
 * @param {*} query
 */
export const startProductCodePut = (query) => {
  return request({
    url: `${prefix}/product/startProductCode/list`,
    method: 'put',
    data: query
  })
}